import requestBuilder from '@/requestBuilder'

export const apiMessage = {
  sendSingleMessage ({ userId, body }) {
    return requestBuilder.post({ path: `/users/${userId}/new_message`, body, kingsChat: true })
  }
}
